import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ajax-submitter"
export default class extends Controller {
  static values = {
    url: String,
    data: String,
    successMessage: String,
  }

  async submit() {
    await fetch(this.urlValue, {
      method: "POST",
      body: this.dataValue,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
      },
    })

    // ToDo: Implement response handling

    // const data = await result.json()
    // console.log({
    //   data,
    //   success: this.successMessageValue,
    // })
  }

  get csrfToken() {
    return document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content")
  }
}
